import styled from 'styled-components';

export const Scope = styled.div`
  width: 100%;
  padding: 50px 0;

  & > div:first-child {
    margin: 0 auto;
  }
`;
